if (document.getElementById('quick-allergy-check-test')) {
    class getTranslationUtilities {
        getTranslation(text) {
            try {
                switch (text) {
                    case 'Eyes':
                        return 'Augen';
                    break;            
                    case "How are your child’s eyes affected?":
                        return 'Wie sind die Augen deines Kindes betroffen?';
                    break;            
                    case 'Itchy':
                        return 'Jucken';
                    break;            
                    case 'Watery':
                        return 'Tränen';
                    break;            
                    case 'Red':
                        return 'Gerötet';
                    break;            
                    case 'Nose':
                        return 'Nase';
                    break;  
                    case "How is your child’s nose affected?":
                        return 'Wie ist die Nase deines Kindes betroffen?';
                    break; 
                    case 'Stuffy':
                        return 'Verstopft';
                    break;            
                    case 'Runny':
                        return 'Rinnt';
                    break;            
                    case 'Sneezing':
                        return 'Niesen';
                    break;                       
                    case 'Tiredness':
                        return 'Müdigkeit';
                    break;  
                    case "How are your child’s sleep and energy levels affected?":
                        return 'Wie sind der Schlaf und die Energie deines Kindes betroffen?';
                    break;           
                    case "Does your child have any of these breathing issues?":
                        return 'Hat dein Kind eines oder mehrere dieser Atemwegsprobleme?';
                    break;
                    case 'Coughing':
                        return 'Husten';
                    break;            
                    case 'Tight chest':
                        return 'Engegefühl in der Brust';
                    break;                       
                    case 'Wheezing':
                        return 'Pfeifende Atmung';
                    break;         
                    case 'None':
                        return 'Keine';
                    break;  
                    case "Which aspects of your child’s life are affected?":
                        return 'Welche täglichen Lebensbereiche deines Kindes sind beeinträchtigt?';
                    break;
                    case 'Family routines':
                        return 'Familienleben';
                    break;            
                    case 'Concentration and school':
                        return 'Konzentration und Schule';
                    break;                       
                    case 'Sports':
                        return 'Sport';
                    break;         
                    case 'Activities':
                        return 'Aktivitäten';
                    break;
                    case "When are your child’s symptoms worst?":
                        return 'Wann sind die Symptome deines Kindes am stärksten?';
                    break;   
                    case 'Spring':
                        return 'Frühling';
                    break;            
                    case 'Summer':
                        return 'Sommer';
                    break;                       
                    case 'Fall':
                        return 'Herbst';
                    break;         
                    case 'Winter':
                        return 'Winter';
                    break;
                    case 'All year round':
                        return 'Das ganze Jahr';
                    break;            
                    case 'Indoors':
                        return 'In Innenräumen';
                    break;                       
                    case 'Outdoors':
                        return 'Im Freien';
                    break;         
                    case 'I don’t know':
                        return 'Weiß ich nicht';
                    break;  
                    case "Any idea what triggers your child’s symptoms?":
                        return 'Hast du eine Idee, was die Symptome deines Kindes auslösen könnte?';
                    break;  
                    case 'Pollen':
                        return 'Pollen';
                    break;            
                    case 'Dust mites':
                        return 'Hausstaubmilben';
                    break;                       
                    case 'Animals':
                        return 'Tiere';
                    break;  
                    case 'Other':
                        return 'Anderes';
                    break;  
                    case "Don't know or other":
                        return 'Weiß ich nicht oder anderes';
                    break;  
                    case "Does anyone in your family have allergic conditions such as hay fever, asthma, food allergies, hives or rashes?":
                        return 'Hat jemand in der Familie deines Kindes allergische Erkrankungen (Neurodermitis, Nahrungsmittelallergien, allergischen Schnupfen, allergisches Asthma)?';
                    break;  
                    case 'Yes':
                        return 'Ja';
                    break;  
                    case 'No':
                        return 'Nein';
                    break;
                    case "Has your child ever had these conditions?":
                        return 'Hat oder hatte dein Kind folgende Erkrankungen?';
                    break;  
                    case 'Eczema':
                        return 'Ekzeme (z.B. Neurodermitis)';
                    break;  
                    case 'Reactions to food such as milk and eggs':
                        return 'Reaktionen auf Lebensmittel (z.B. Milch, Eier, Äpfel o.Ä.)';
                    break;  
                    case 'Asthma':
                        return 'Asthma';
                    break;  
                    case 'Select specific symptoms':
                        return 'Wähle alle zutreffenden Symptome';
                    break;  
                    case 'Rate the overall impact':
                        return 'Beeinträchtigung durch die Symptome generell';
                    break;  
                    case 'NOT AFFECTED':
                        return 'GAR NICHT BETROFFEN';
                    break;  
                    case 'VERY AFFECTED':
                        return 'STARK BETROFFEN';
                    break;  
                    case 'Understand the scale':
                        return 'Die Skala verstehen';
                    break;  
                    case 'BACK':
                        return 'ZURÜCK';
                    break;  
                    case 'NEXT':
                        return 'WEITER';
                    break;  
                    case 'Submit':
                        return 'Ergebnis anzeigen';
                    break;  
                    case "Your child doesn't seem affected":
                        return 'Dein Kind scheint nicht betroffen zu sein';
                    break;  
                    case "You've rated their symptoms as zero impact. But if you're worried, it's a good idea to discuss the full report with your doctor.":
                        return 'Du hast die abgefragten Symptome mit Null eingestuft. Wenn du dir dennoch Sorgen um die Beschwerden deines Kindes machst, ist es eine gute Idee, diese trotzdem mit eurer Ärztin oder eurem Arzt zu besprechen.';
                    break;  
                    case "Your child's symptoms seem to be mild":
                        return 'Dein Kind scheint leicht betroffen zu sein';
                    break;  
                    case "You've rated their strongest symptoms as minor. But if you're worried, it's a good idea to discuss the full report with your doctor.":
                        return 'Du hast die stärksten Symptome insgesamt als leicht eingestuft. Aber wenn du dir Sorgen machst, ist es eine gute Idee, den kompletten Bericht mit eurer Ärztin oder eurem Arzt zu besprechen.';
                    break;  
                    case "Your child seems somewhat affected":
                        return 'Dein Kind scheint mässig betroffen zu sein';
                    break;  
                    case "You've rated their strongest symptoms as noticeable. Talk the full report through with your doctor to figure what's going on.":
                        return 'Du hast die stärksten Symptome insgesamt als mässig eingestuft. Besprich den kompletten Bericht mit eurer Ärztin oder eurem Arzt, um der Sache auf den Grund zu gehen.';
                    break;  
                    case "Your child seems to be struggling with symptoms":
                        return 'Dein Kind scheint stark betroffen zu sein';
                    break;  
                    case "You've rated their strongest symptoms as significant. Talk the full report through with your doctor so your child can get the right treatment advice.":
                        return 'Du hast die stärksten Symptome insgesamt auch als stark eingestuft. Besprich den kompletten Bericht mit eurer Ärztin oder eurem Arzt, damit dein Kind eine adäquate Behandlung bekommen kann.';
                    break;  
                    case "Your child's life doesn't seem to be affected by their symptoms.":
                        return 'Das Leben deines Kindes scheint nicht durch die Symptome beeinträchtigt zu sein.';
                    break;  
                    case "Your child's symptoms are starting to take over parts of their life.":
                        return 'Die Symptome deines Kindes haben angefangen, sich auf Teile des täglichen Lebens auszuwirken.';
                    break;  
                    case "There's a lot your child can't do or has to put up with due to their symptoms.":
                        return 'Es gibt viel, das dein Kind aufgrund der Symptome nicht machen kann oder mit dem es sich derzeit abfinden muss.';
                    break;  
                    case "Strongest symptoms":
                        return 'Stärkste Symptome';
                    break;  
                    case "GET FULL REPORT":
                        return 'HOL DIR DEN KOMPLETTEN BERICHT';
                    break;  
                    case "How daily life is affected":
                        return 'Auswirkungen auf das tägliche Leben';
                    break;  
                    case "Suspected triggers":
                        return 'Vermutete Auslöser';
                    break;  
                    case "Tiredness or sleep disruptions":
                        return 'Müdigkeit oder Schlafprobleme';
                    break;  
                    case "Yes, our family does have a history of allergic conditions such as hay fever, asthma, food allergies, hives or rashes.":
                        return 'Ja, in unserer Familie kommen allergische Erkrankungen (Neurodermitis, Nahrungsmittelallergien, allergischer Schnupfen, allergisches Asthma) vor.';
                    break;  
                    case "No, no one in our family has allergic conditions such as hay fever, asthma, food allergies, hives or rashes.":
                        return 'Nein, niemand in unserer Familie hat allergische Erkrankungen (Neurodermitis, Nahrungsmittelallergien, allergischer Schnupfen, allergisches Asthma).';
                    break;  
                    case "I don’t know if anyone in our family has allergic conditions such as hay fever, asthma, food allergies, hives or rashes.":
                        return 'Ich weiß nicht, ob jemand in unserer Familie allergische Erkrankungen (Neurodermitis, Nahrungsmittelallergien, allergischen Schnupfen, allergisches Asthma) hat.';
                    break;  
                    case "My child's allergy check":
                        return 'Allergie-Schnellcheck meines Kindes';
                    break;  
                    case "The full report is for the doctor, designed with guidance from other doctors to collect the details they need. Bring it with you to the appointment.":
                        return 'Der komplette Bericht ist für eure Ärztin oder euren Arzt, und wurde zusammen mit anderen Ärztinnen und Ärzten entworfen, um wichtige Informationen für das Arztgespräch zu sammeln. Nimm ihn mit zum Termin.';
                    break;  
                    case "My child’s symptom overview":
                        return 'Symptomübersicht meines Kindes';
                    break;  
                    case "The VAS for allergic rhinitis (nose symptoms) and allergic conjunctivitis (eye symptoms) adapted from: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.":
                        return 'Die VAS, oder visuelle Analogskala, ist ein Instrument zur Bewertung des Schweregrads von Allergiesymptomen. Sie wurde angepasst in Anlehnung an: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.';
                    break;  
                    case "BREATHING ISSUES":
                        return 'ATEMWEGSPROBLEME';
                    break;  
                    case "Impact on daily life":
                        return 'Auswirkungen auf das tägliche Leben';
                    break;  
                    case "ASPECTS OF MY CHILD'S LIFE AFFECTED":
                        return 'BEEINTRÄCHTIGTE LEBENSBEREICHE MEINES KINDES';
                    break;  
                    case "Timing and triggers":
                        return 'Timing und Auslöser';
                    break;  
                    case "WHEN SYMPTOMS ARE WORST":
                        return 'DIE SYMPTOME SIND DANN AM STÄRKSTEN';
                    break;  
                    case "Medical history":
                        return 'Vorerkrankungen';
                    break;  
                    case "ALLERGIES IN OUR FAMILY":
                        return 'ALLERGISCHE ERKRANKUNGEN <br class="d-block d-md-none">IN UNSERER FAMILIE';
                    break;  
                    case "MY CHILD HAS OR USED TO HAVE:":
                        return 'MEIN KIND HAT ODER HATTE FOLGENDE ERKRANKUNGEN:';
                        return '';
                    break; 
                    case "You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.":
                        return 'Du erhältst in Kürze eine Bestätigungs-E-Mail. Bitte klicke auf den Link in der E-Mail, damit wir wissen, dass du es bist. Dann schicken wir dir den Allergie-Schnellcheck.';
                    break; 
                    case "Your child's report has been sent now. Thank you for doing the Quick Allergy Check.":
                        return 'Der komplette Bericht deines Kindes wurde jetzt abgeschickt. Wir hoffen, dass dich der Allergie-Schnellcheck beim Arztgespräch unterstützen kann.';
                    break;
                }
    
            } catch (e) {
                console.error(e);
            }
        }
    }
    var getTranslationUtility = new getTranslationUtilities();
    
    window.quickAllergyCheck = {
        questions: [
            {
                question: getTranslationUtility.getTranslation('How are your child’s eyes affected?'),
                category: getTranslationUtility.getTranslation('Eyes'),
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Watery'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Red'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_1_eye_top_icon_blue.svg',
                image: ''
            },
            {
                question: getTranslationUtility.getTranslation('How is your child’s nose affected?'),
                category: getTranslationUtility.getTranslation('Nose'),
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Stuffy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Runny'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Sneezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_2_nose_top_icon_blue.svg',
                image: ''
            },
            {
                question: getTranslationUtility.getTranslation('How are your child’s sleep and energy levels affected?'),
                category: getTranslationUtility.getTranslation('Tiredness'),
                multipleOptions: [],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_4_tiredness_top_icon_blue.svg',
                image: ''
            },
            {
                question: getTranslationUtility.getTranslation('Does your child have any of these breathing issues?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Coughing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Tight chest'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Wheezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('None'),
                        disable: true,
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/Group_7703.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Which aspects of your child’s life are affected?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Family routines'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Concentration and school'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Sports'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Activities'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('None'),
                        disable: true,
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_step_05_blobs_test.svg',
                imagePosition: {
                    bottom: '15px',
                    right: '10px',
                }
            },
            {
                question: getTranslationUtility.getTranslation('When are your child’s symptoms worst?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Spring'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Indoors'),
                        attribute: '',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Summer'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Outdoors'),
                        attribute: '',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Fall'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('I don’t know'),
                        disable: true,
                        attribute: '',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Winter'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('All year round'),
                        attribute: 'all season',
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_step_06_blobs_test.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Any idea what triggers your child’s symptoms?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Pollen'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Dust mites'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Animals'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Other'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('I don’t know'),
                        disable: true,
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_step_07_blobs_test.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Does anyone in your family have allergic conditions such as hay fever, asthma, food allergies, hives or rashes?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Yes'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('No'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('I don’t know'),
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_step_08_blobs_test.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Has your child ever had these conditions?'),
                category: '',
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Eczema'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Reactions to food such as milk and eggs'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Asthma'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('None'),
                        disable: true,
                    }
                ],
                logoImage: '',
                image: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_step_09_blobs_test.svg'
            }
        ],
        answers: [
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                category: '',
                vas_score: null
            }
        ],
        indicatorImages: [
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_green_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_orange_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_red_blob_test.svg',
        ],
        highestVASScore: 0,
        highestVASScoreSpanHTML: '',
        highestVASCategory: [],
        imageCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
        highestVASColor: '#009DC1',
        reportHeading: getTranslationUtility.getTranslation("Your child doesn't seem affected"),
        reportText: getTranslationUtility.getTranslation("You've rated their symptoms as zero impact. But if you're worried, it's a good idea to discuss the full report with your doctor."),
        currentQuestion: 1,
        nextQuestion: 2,
        previousQuestion: 0,
        currentStep: 'step-1',
        indicatorPopUp: document.querySelector('.indicatorValueOverlay'),
        introSlide: document.querySelector('.quizBackgroundColor .introSlide'),
        questionSlide: document.querySelector('.quizBackgroundColor .questionSlide'),
        closeQuizPopup: document.querySelector('[data-close-quiz-popup]'),
        closeQuizBackbtnPopup: document.querySelector('[data-close-quiz-backbtn-popup]'),
        tabContainer: document.querySelector('.result .tabContainer'),
        summaryContentContainer: document.querySelector('#summaryTab'),
        doctorContentContainer: document.querySelector('#doctorTab'),
        commonResultContentContainer: document.querySelector('.commonResultContent'),
        signupForm: document.querySelector('#brazeFormMain form'),
        unsavedChanges: true,
        knownUser: false,
        newsletterSignupVal: 'off',
        answerStorage: [],
        QACID_Cookie: null,
        QAC_email: null,
       
        init() {
            if(document.querySelector('body').classList.contains('quick-allergy-check')){
                setTimeout(function(){
                    document.querySelector('#app').classList.remove('loading');
                },2500);
            }

            this.setHTML();
            let newsletterSignupCheckbox = document.querySelector('.brazeFormContainer.signup .newsletter_signup_checkbox');
            if (this.getCookie('QACID_Cookie') != '' && this.getCookie('QACID_Cookie') != null && this.getCookie('QACID_Cookie') != 'QACID_Cookie') {
                this.QACID_Cookie = this.getCookie('QACID_Cookie');
            }
            else {
                this.QACID_Cookie = localStorage.getItem('QACID_Cookie');
            }
            if (this.QACID_Cookie != null) {
                this.knownUser = true;
                newsletterSignupCheckbox.classList.add('d-none');
                // document.querySelector('.brazeFormContainer.result').classList.remove('d-none');
                // document.querySelector('.brazeFormContainer.signup').classList.add('d-none');
            }
            else {
                this.knownUser = false;
            }

            window.addEventListener('popstate', (event) => {
                if (this.unsavedChanges) {
                    this.closeQuizBackbtnPopup.classList.remove('d-none');
                }
            });
            // Initial state to prevent direct back navigation
            history.pushState(null, '', location.href);
            

            document.querySelector('#startQuiz').addEventListener('click', (e) => {
                e.preventDefault();
                if(document.querySelector('input[name="user_consent"]').checked) {
                    this.introSlide.classList.add('d-none');
                    this.questionSlide.classList.remove('d-none');
                    window.dataLayer.push({
                        'event': 'qac_started'
                    });
                }
                else {
                    document.querySelector('.quick-allergy-check .introSlide .consent_checkbox_wrapper').classList.add('required');
                    setTimeout(function() {
                        document.querySelector('.quick-allergy-check .introSlide .consent_checkbox_wrapper').classList.remove('required');
                    },2000);
                    window.dataLayer.push({
                        'event': 'qac_started_consent_no'
                    });
                }
            });
            document.querySelectorAll('.scale-container .indicatorPopUpTextContainer').forEach(indicatorpopupText => {
                indicatorpopupText.addEventListener('click', () => {
                    this.indicatorPopUp.classList.remove('d-none');
                })
            });
            this.indicatorPopUp.querySelector('.navigation-icon').addEventListener('click', () => {
                this.indicatorPopUp.classList.add('d-none');
            })
            document.querySelectorAll('input[type="range"]').forEach(slider => {
                slider.addEventListener('change', (e) => {
                    let parentElement = e.currentTarget.closest('.scale-container');
                    let imageElement = parentElement.querySelector('img');
                    if (e.currentTarget.value == 0) {

                        imageElement.src = this.indicatorImages[0];
                    }
                    if (e.currentTarget.value == 1) {

                        imageElement.src = this.indicatorImages[1];
                    }
                    if (e.currentTarget.value < 5 && e.currentTarget.value > 1) {
                        imageElement.src = this.indicatorImages[2];
                    }
                    if (e.currentTarget.value > 4) {
                        imageElement.src = this.indicatorImages[3];
                    }
                })
            });
            document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    let inputName = e.currentTarget.name;
                    let currentQuestionCheckboxes = document.querySelectorAll(`input[name="${inputName}"]`);
                    if (e.currentTarget.hasAttribute("data-none-option")) {
                        if (e.currentTarget.checked) {
                            currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                                if (!currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                    currentQuestionCheckbox.checked = false
                                }
                            });
                        }
                    }
                    else {
                        currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                            if (currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                currentQuestionCheckbox.checked = false;
                            }
                        });
                    }
                });
            });
            document.querySelectorAll('#step-6 input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    if (checkbox.hasAttribute('data-attribute')) {

                        let dataAttributeValue = checkbox.getAttribute('data-attribute')
                        if (dataAttributeValue == "all season") {
                            document.querySelectorAll('#step-6 input[type="checkbox"][data-attribute="season"]').forEach(otherCheckbox => {
                                otherCheckbox.checked = false;
                            })
                        }
                        else {
                            document.querySelector('#step-6 input[type="checkbox"][data-attribute="all season"]').checked = false;
                        }
                    }
                });
            });
            document.querySelectorAll('#step-8 input[type="checkbox"]').forEach(input => {
                input.addEventListener('change', (e) => {
                    if (input.checked) {
                        document.querySelectorAll('#step-8 input[type="checkbox"]').forEach(otherCheckbox => {
                            if (otherCheckbox !== input) {
                                otherCheckbox.checked = false;
                            }
                        });
                    }
                });
            });

            // vas score slider/checkbox pulsing logic start 
            function pulseElement(el) {
                if (!el) return;
                el.classList.remove('pulse');
                void el.offsetWidth;
                el.classList.add('pulse');
                setTimeout(() => {
                    el.classList.remove('pulse');
                    void el.offsetWidth;
                    el.classList.add('pulse');
                    el.addEventListener('animationend', function handler() {
                        el.classList.remove('pulse');
                        el.removeEventListener('animationend', handler);
                    });
                }, 300);
            }
            function handleStep(stepId) {
                let stepContainer = document.querySelector(stepId);
                if (!stepContainer) return;
                let nextBtn = stepContainer.querySelector('.rightNavigation button');
                function updateButtonState(e) {
                    let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                    let rangeInput = stepContainer.querySelector('input[type="range"]');
                    var rangeValue = Number(stepContainer.querySelector('input[type="range"]').value);
                    if (e?.target?.type === 'checkbox' &&
                        !e.target.checked &&
                        checkedBoxes === 0 &&
                        rangeValue !== 0
                    ) {
                        rangeInput.value = 0;
                        rangeValue = 0;
                        let characterImg = stepContainer.querySelector('.character img');
                        if (characterImg) {
                            characterImg.src = 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg';
                        }
                        rangeInput.dispatchEvent(new Event('input'));
                    }
                    let isValid = (checkedBoxes == 0 && rangeValue == 0) || (checkedBoxes > 0 && rangeValue > 0);
                    // nextBtn.disabled = !isValid;
                    nextBtn.classList.toggle('soft-disabled', !isValid);
                    nextBtn.style.opacity = isValid ? '1' : '0.5';
                }
                //stepContainer.addEventListener('change', updateButtonState);
                stepContainer.addEventListener('input', updateButtonState);
            }
            handleStep('#step-1');
            handleStep('#step-2');
            // end vas score slider/checkbox pulsing logic end

            document.querySelectorAll('.navigationButtonContainer').forEach(navigationBtnEl => {
                navigationBtnEl.addEventListener('click', (e) => {
                    let requestedStep = '';
                    if (e.currentTarget.hasAttribute("data-next-step")) {
                        let questionStep = document.querySelector(`.questionAnswer#${this.currentStep}`)
                        let answer = {event: questionStep.id, answerValue: []};
                        this.getAnswer(answer);
                        requestedStep = e.currentTarget.getAttribute('data-next-step');
                        if (requestedStep != 'step-result') {

                            // vas score slider/checkbox pulsing logic start 
                            if (e.currentTarget.classList.contains("soft-disabled")) {
                                let stepContainer = e.currentTarget.closest('.questionAnswer');
                                let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                                let rangeInput = stepContainer.querySelector('input[type="range"]');
                                let rangeValue = rangeInput ? Number(rangeInput.value) : 0;
                                let optionsContainer = stepContainer.querySelector('.symptomsOptionContainer, .checkboxesContainer');
                                let scaleContainer = stepContainer.querySelector('.scale-container');
                                if (checkedBoxes > 0 && rangeValue === 0) {
                                    pulseElement(scaleContainer);
                                }
                                if (checkedBoxes === 0 && rangeValue > 0) {
                                    pulseElement(optionsContainer);
                                }
                                e.preventDefault();
                                return false;
                            }
                            // vas score slider/checkbox pulsing logic end

                            document.querySelector(`.questionAnswer#${requestedStep}`).classList.remove('d-none');
                            document.querySelector(`.questionAnswer#${this.currentStep}`).classList.add('d-none');

                            // if (this.getCookie('BUID_Cookie')) {
                            //     this.answerStorage.forEach(obj => {
                            //         if (obj.step === questionStep.id) {
                            //             this.answerStorage.splice(this.answerStorage.indexOf(obj), 1);
                            //         }
                            //     })
                            //     this.answerStorage.push(answer)
                            // } else {
                                window.dataLayer.forEach(obj => {
                                    if (obj.step === questionStep.id) {
                                        window.dataLayer.splice(window.dataLayer.indexOf(obj), 1);
                                    }
                                })
                                window.dataLayer.push(answer)
                            // }
                        }
                        if ((requestedStep == 'step-result')) {
                            document.querySelector(`#${requestedStep}`).classList.remove('d-none');
                            document.querySelector('.quizBackgroundColor').classList.add('d-none');
                            if (this.getCookie('QACID_Cookie') != '' && this.getCookie('QACID_Cookie') != null && this.getCookie('QACID_Cookie') != 'QACID_Cookie') {
                                let bodyData = {
                                    "response": this.answers,
                                    "email": this.QAC_email,
                                    "external_id": this.QACID_Cookie,
                                    "language": 'de',
                                };
                                this.sendAnswer(bodyData);
                            }

                            // if (this.getCookie('BUID_Cookie')) {
                            //     this.answerStorage.forEach(obj => {
                            //         if (obj.step === questionStep.id) {
                            //             this.answerStorage.splice(this.answerStorage.indexOf(obj), 1);
                            //         }
                            //     })
                            //     this.answerStorage.push(answer)
                            // } else {
                                window.dataLayer.forEach(obj => {
                                    if (obj.step === questionStep.id) {
                                        window.dataLayer.splice(window.dataLayer.indexOf(obj), 1);
                                    }
                                })
                                window.dataLayer.push(answer)
                            // }
                            this.getBiggestIndicatorValue();
                            this.createSummaryHTML();
                            document.querySelectorAll('#quick-allergy-check-test input[type="checkbox"]').forEach(allCheckboxes => {
                                allCheckboxes.checked = false;
                            });
                            document.querySelectorAll('#quick-allergy-check-test input[type="range"]').forEach(allRangboxes => {
                                allRangboxes.value = 0;
                            });

                            window.dataLayer.push({
                                'event': 'qac_completed'
                            });
                        }
                    }
                    else {
                        requestedStep = e.currentTarget.getAttribute('data-previous-step');
                        document.querySelector(`.questionAnswer#${requestedStep}`).classList.remove('d-none');
                        document.querySelector(`.questionAnswer#${this.currentStep}`).classList.add('d-none');
                    }
                    let newString = requestedStep.split("-");
                    this.currentStep = requestedStep;
                    this.currentQuestion = newString[1];
                    let stepElements = document.querySelectorAll('.descriptionContainer .pagination .step');
                    this.enableNextBtn();
                    for (let i = 0; i < stepElements.length; i++) {
                        stepElements[i].classList.remove('completed');
                        stepElements[i].classList.remove('active');
                        if (i <= [this.currentQuestion - 2]) {
                            stepElements[i].classList.add('completed');
                        }
                    }
                    if (requestedStep != 'step-result') {
                        stepElements[this.currentQuestion - 1].classList.add('active');
                    }
                });
            });
            document.querySelectorAll('.tabContainer button').forEach(button => {
                button.addEventListener('click', (e) => {
                    let dataTabType = e.currentTarget.getAttribute('data-tab');
                    if (dataTabType == 'summaryTab') {
                        this.summaryContentContainer.classList.remove('d-none');
                        this.doctorContentContainer.classList.add('d-none');
                        this.commonResultContentContainer.dataset.tab = 'summary';
                        this.tabContainer.style.backgroundColor = '#8dcec8';
                        document.querySelector(".resultContainer").style.backgroundColor = '#c7dced';
                        this.createSummaryHTML();
                        document.querySelector('.tabContainer button[data-tab="summaryTab"]').classList.add('active');
                        document.querySelector('.tabContainer button[data-tab="doctorTab"]').classList.remove('active');

                    }
                    else {
                        this.summaryContentContainer.classList.add('d-none');
                        this.doctorContentContainer.classList.remove('d-none');
                        this.commonResultContentContainer.dataset.tab = 'doctor';
                        this.tabContainer.style.backgroundColor = '#98C2E5';
                        document.querySelector(".resultContainer").style.backgroundColor = '#CAE5E0';
                        this.createDoctorHTML();
                        document.querySelector('.tabContainer button[data-tab="doctorTab"]').classList.add('active');
                        document.querySelector('.tabContainer button[data-tab="summaryTab"]').classList.remove('active');
                        window.dataLayer.push({
                            'event': 'qac_report_download'
                        });
                    }
                });
            });
            document.querySelector('[data-result-close]').addEventListener('click', () => {
                if(document.querySelector('#brazeFormMain .signup').classList.contains('d-none')){
                    // if ((document.referrer).includes('/pages/kinder-und-allergien-herbstzeit')) {
                    //     window.location.href = "https://at.klarify.me//pages/kinder-und-allergien-herbstzeit";
                    // }
                    // else if ((document.referrer).includes('/pages/kinder-mit-allergie')) {
                    //     window.location.href = "https://at.klarify.me//pages/kinder-mit-allergie";
                    // }
                    // else {
                        window.location.href = "https://at.klarify.me/pages/kinder-und-allergien"
                    // }
                }
                else{ 
                    this.closeQuizPopup.classList.remove('d-none');
                }
            });
            document.querySelector('[data-intro-close]').addEventListener('click', () => {
                // if ((document.referrer).includes('/pages/kinder-und-allergien-herbstzeit')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-und-allergien-herbstzeit";
                // }
                // else if ((document.referrer).includes('/pages/kinder-mit-allergie')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-mit-allergie";
                // }
                // else {
                    window.location.href = "https://at.klarify.me/pages/kinder-und-allergien";
                // }
            });
            document.querySelector('[data-question-close]').addEventListener('click', () => {
                // this.introSlide.classList.remove('d-none');
                // this.questionSlide.classList.add('d-none');
                // if ((document.referrer).includes('/pages/kinder-und-allergien-herbstzeit')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-und-allergien-herbstzeit";
                // }
                // else if ((document.referrer).includes('/pages/kinder-mit-allergie')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-mit-allergie";
                // }
                // else {
                    window.location.href = "https://at.klarify.me/pages/kinder-und-allergien";
                // }
            });
            document.querySelector('.quizPopupOverlay[data-close-quiz-popup] .noBtn').addEventListener('click', () => {
                this.closeQuizPopup.classList.add('d-none');
                document.getElementById("brazeFormMain").scrollIntoView();
            });
            document.querySelector('.quizPopupOverlay[data-close-quiz-popup] .yesBtn').addEventListener('click', () => {
                // if ((document.referrer).includes('/pages/kinder-und-allergien-herbstzeit')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-und-allergien-herbstzeit";
                // }
                // else if ((document.referrer).includes('/pages/kinder-mit-allergie')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-mit-allergie";
                // }
                // else {
                    window.location.href = "https://at.klarify.me/pages/kinder-und-allergien";
                // }
            });

            document.querySelector('.quizPopupOverlay[data-close-quiz-backbtn-popup] .noBtn').addEventListener('click', () => {
                this.closeQuizBackbtnPopup.classList.add('d-none');
            });
            document.querySelector('.quizPopupOverlay[data-close-quiz-backbtn-popup] .yesBtn').addEventListener('click', () => {
                // if ((document.referrer).includes('/pages/kinder-und-allergien-herbstzeit')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-und-allergien-herbstzeit";
                // }
                // else if ((document.referrer).includes('/pages/kinder-mit-allergie')) {
                //     window.location.href = "https://at.klarify.me//pages/kinder-mit-allergie";
                // }
                // else {
                    window.location.href = "https://at.klarify.me/pages/kinder-und-allergien";
                // }
            });

            this.signupForm.querySelector('button').addEventListener('click', async (event) => {
                event.preventDefault();
                let nameInput = this.signupForm.querySelector('input[name="first_name"]');
                let emailInput = this.signupForm.querySelector('input[name="email"]');
                const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                let verifiedEmail = emailInput.value.match(emailPattern);
                let verifiedName = nameInput.value.match(/^[A-Za-z ]+$/);
                let consentBox = this.signupForm.querySelector('input[data-consent-checkbox]');
                let concentBox2 = this.signupForm.querySelector('input[data-consent-checkbox2]');
                let inputs = [emailInput];
                let emailValue = emailInput.value;
                inputs.forEach(input =>{
                    input.addEventListener('blur', () =>{
                        if(input.classList.contains('required') && input.value != null) {
                            input.classList.remove('required');
                        }
                    })
                })
                if (this.getCookie('BUID_Cookie')) {
                    this.answerStorage.forEach(obj => {
                        window.dataLayer.push(obj);
                    })
                }
                if(verifiedEmail == null) {
                    emailInput.classList.add('required');
                }
                // if(verifiedName == null) {
                //     nameInput.classList.add('required');
                // }
                if(!consentBox.checked) {
                    let parent = consentBox.closest('.checkbox-label');
                    let checkMark = parent.querySelector('.custom-checkmark');
                    checkMark.classList.add('required');
                }
                if(verifiedEmail && consentBox.checked) {
                    let formData = new FormData(this.signupForm);
                    formData.append(
                        'existing_external_id',
                        md5(emailValue)
                    )
                    const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                        method: "POST",
                        body: formData,
                    });
                    const res = await response.json();
                    if (response.status == 200) {
                        if (consentBox.checked && !concentBox2.checked) {
                            // window.dataLayer.push({
                            //     event: 'web_cgr_report_form',
                            //     status1: 'Yes',
                            //     status2: 'No'
                            // });
                            window.dataLayer.push({
                                'event': 'qac_report_result_signup',
                                'status':'no',
                            });
                        } else if (consentBox.checked && concentBox2.checked) {
                            // window.dataLayer.push({
                            //     event: 'web_cgr_report_form',
                            //     status1: 'Yes',
                            //     status2: 'Yes'
                            // });
                            window.dataLayer.push({
                                'event': 'qac_report_result_signup',
                                'status':'yes',
                            });
                        }
                        if(res.data.attributes[0].external_id != '') {
                            if (typeof braze !== 'undefined') {
                                //braze sdk is loaded and we can tun the changeUser function
                                braze.changeUser(this.responseText);
                            }
                            if (typeof appboy !== 'undefined') {
                                //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                                appboy.changeUser(this.responseText);
                            }
                            if (this.getCookie('BUID_Cookie') == '' || this.getCookie('BUID_Cookie') == undefined) {
                                this.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                            }
                            // this.setCookie('QACID_Cookie', res.data.attributes[0].external_id);
                            // this.setCookie('QAC_email', emailValue);
                            this.QACID_Cookie = res.data.attributes[0].external_id;
                            this.QAC_email = emailValue;

                            let thankyouText = '';
                            if(this.knownUser){
                                thankyouText = getTranslationUtility.getTranslation("Your child's report has been sent now. Thank you for doing the Quick Allergy Check.");;
                            }
                            else {
                                let newsletterSignup = document.querySelector('.brazeFormContainer.signup input[name="newsletter_signup"]');
                                if(newsletterSignup.checked) {
                                    thankyouText = getTranslationUtility.getTranslation("You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.");
                                    document.querySelector('.brazeFormContainer.result .resultMessage').classList.remove('d-none');
                                    this.newsletterSignupVal = 'on';
                                }
                                else {
                                    thankyouText = getTranslationUtility.getTranslation("Your child's report has been sent now. Thank you for doing the Quick Allergy Check.");
                                    this.newsletterSignupVal = 'off';
                                }
                            }
                            document.querySelector('.brazeFormContainer.result .description').innerHTML = thankyouText;

                            document.querySelector('.brazeFormContainer.result').classList.remove('d-none');
                            document.querySelector('.brazeFormContainer.result').classList.add('d-flex');
                            document.querySelector('.brazeFormContainer.signup').classList.add('d-none');
                            document.querySelector('.brazeFormContainer.signup').classList.remove('d-flex');
                            document.querySelectorAll('#brazeFormMain input[type="checkbox"]').forEach(formCheckboxes => {
                                formCheckboxes.checked = false;
                            }); 
                            document.querySelectorAll('#brazeFormMain input[type="text"], #brazeFormMain input[type="email"]').forEach(formInputboxes => {
                                formInputboxes.value = '';
                            });
                            let bodyData = {
                                "response": this.answers,
                                "email": emailValue,
                                // "external_id": this.getCookie('QACID_Cookie'),
                                 "external_id": this.QACID_Cookie,
                                "language": 'de',
                            };
                            this.sendAnswer(bodyData);
                        }
                    }
                    this.unsavedChanges = false;
                }
            });
        },
        setHTML() {
            let questionsHTML = '';
            this.questions.forEach((question, questionIndex) => {
                //option html for indicator
                let indicatorOptions = ``;
                question.multipleOptions.forEach((option) => {
                    let indicatorOption = `
                        <div class="symptomsOption">
                            <label>
                                <input type="checkbox" name="symptom-${questionIndex}" value="${option.title}">
                                <span>${option.title}</span>
                            </label>
                        </div>
                    `;
                    indicatorOptions += indicatorOption;
                });

                let indicatorAnswerHTML = `
                    <div data-options-type="indicatorOptions">
                        <img
                            class="symptomsImage"
                            src="${question.logoImage}"
                            alt="${question.category} logo"
                        >
                        <div class="symptomsContainer">
                            <div class="symptomsCategory">${question.category}</div>
                            ${indicatorOptions.length > 0 ? `
                                <div class="symptomsHeading">${getTranslationUtility.getTranslation('Select specific symptoms')}</div>
                                <div class="symptomsOptionContainer">
                                    ${indicatorOptions}
                                </div>` : ``
                    }
                        </div>
                        <div class="indicatorContainer">
                            <div class="indicatorHeading">${getTranslationUtility.getTranslation('Rate the overall impact')}</div>
                                <div class="scale-container mx-auto">
                                    <div class="position-relative">
                                        <input type="range" min="0" max="10" value="0" class="slider" id="${question.category}">
                                        <div class="number-labels">
                                            <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                            <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                        </div>
                                    </div>
                                    <div class="labels">
                                        <span class="sliderNotAffected indicatorText">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                        <span class="sliderVeryAffected indicatorText">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                    </div>
                                    <div class="character">
                                        <img
                                            src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg"
                                            alt="Slider Character"
                                        >
                                    </div>
                                    <div class="indicatorPopUpTextContainer">${getTranslationUtility.getTranslation('Understand the scale')}</div>
                                </div>
                            </div>
                    </div>
                `;
                // end of option html for indicator

                // option html for checkbox
                let checkboxClass = '';
                if (question.category == '') {
                    checkboxClass = question.multipleOptions.length > 5 ? 'twoColumn' : '';
                }
                let checkboxOptions = ``;
                question.multipleOptions.forEach((option) => {
                    let checkboxOption = `
                    <label class="checkbox-item">
                        <input type="checkbox" name="symptom-${questionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''} 
                        ${option.attribute != '' && option.attribute != undefined ? `data-attribute="${option.attribute}"` : ''}>
                        <span class="checkmark"></span>
                        ${option.title}
                    </label>
                    `;
                    checkboxOptions += checkboxOption;
                });
                let checkboxAnswerHTML = `
                    <div data-options-type="${question.category == '' ? 'multiCheckboxes' : 'indicatorOptions'}" class="d-md-flex">
                        <div class="checkboxesContainer ${checkboxClass}">
                            ${checkboxOptions}
                        </div>
                        <div class="imageContainer">
                            <img src="${question.image}" alt="${question.question} character">
                        </div>
                    </div>
                `;
                // end of option html for checkbox

                let optionsAnswerHTML = question.category == '' ? checkboxAnswerHTML : indicatorAnswerHTML;
                //html for next button
                let nextButton = `
                    <button class="align-items-center d-flex navigationButtonContainer rightNavigationButtonContainer" ${questionIndex > 2 ? 'disabled' : ''} data-next-step="step-${questionIndex + 2}">
                        <span class="buttonLabel">${getTranslationUtility.getTranslation('NEXT')}</span>
                        <span class="buttonContainer rightButtonContainer">
                            <span class="icon-klarify-Group-3429-2 arrow-glide-animation"></span>
                        </span>
                    </button>
                `;
                let resultButton = `
                    <button class="align-items-center  d-flex navigationButtonContainer rightNavigationButtonContainer" disabled data-next-step="step-result">
                        <span class="buttonLabel">${getTranslationUtility.getTranslation('Submit')}</span>
                        <span class="rightButtonContainer">
                            <span class="icon-klarify-Group-3429-2 arrow-glide-animation"></span>
                        </span>
                    </button>
                `;
                let nextResultButton = questionIndex == [this.questions.length - 1] ? resultButton : nextButton;
                let questionHTML = `
                    <div class="questionAnswer ${questionIndex == 0 ? '' : 'd-none'}" id="step-${questionIndex + 1}" >
                        <div class="questionAnswerContainer" data-question-type="${question.category == '' ? 'checkbox' : 'indicator'}">
                            <h3 class="question ${questionIndex == 0 ? 'col-9 col-lg-8' : questionIndex == 1 ? 'col-9 col-lg-8' : questionIndex == 2 ? 'col-10 col-lg-8' : questionIndex == 3 ? 'col-6 col-lg-5' : questionIndex == 4 ? 'col-9 col-lg-5' : questionIndex == 5 ? 'col-7 col-lg-5' : questionIndex == 6 ? 'col-9 col-lg-5' : questionIndex == 7 ? 'col-11 col-lg-10 col-md-8' : questionIndex == 8 ? 'col-9 col-lg-5' : ''} col-md-6 text-center mx-auto">${question.question}</h3>
                            <div class="mainAnswerContainer d-flex align-items-center mx-auto">
                                <div class="leftNavigation">
                                    <button class="align-items-center d-flex navigationButtonContainer leftNavigationButtonContainer ${questionIndex == 0 ? 'invisible' : 'visible'}" data-previous-step="step-${questionIndex}">
                                        <span class="buttonContainer leftButtonContainer">
                                            <span class="icon-klarify-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                        </span>
                                        <span class="buttonLabel">${getTranslationUtility.getTranslation('BACK')}</span>
                                    </button>
                                </div>
                                <div class="answerContainer" data-options>
                                    ${optionsAnswerHTML}
                                </div>
                                <div class="rightNavigation">
                                    ${nextResultButton}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                questionsHTML += questionHTML;
            })
            document.getElementById('quick-allergy-check-test').innerHTML = questionsHTML;
        },
        enableNextBtn() {
            document.querySelectorAll('#quick-allergy-check-test .questionAnswer').forEach(questionAnswer => {
                if (!questionAnswer.classList.contains('d-none')) {
                    let allchecboxes = questionAnswer.querySelectorAll('[data-options-type="multiCheckboxes"] input[type="checkbox"]');
                    if(allchecboxes.length > 0) {
                        allchecboxes.forEach(allchecbox => {
                            allchecbox.addEventListener('change', () => {
                                let allCheckedChecboxes = questionAnswer.querySelectorAll('input[type="checkbox"]:checked');
                                let btn = questionAnswer.querySelector('.rightNavigation button');
                                if (allCheckedChecboxes.length > 0) {
                                    btn.disabled = false;
                                }
                                else {
                                    btn.disabled = true;
                                }
                            });
                        });
                    }
                }
            });
        },
        getAnswer(answer) {
            let dataOptionTypeElement = document.querySelector(`.questionAnswer#${this.currentStep} [data-options-type]`);
            let dataOptionType = dataOptionTypeElement.getAttribute('data-options-type');
            let currentQuestionIndex = this.currentQuestion - 1;
            let question = this.questions[currentQuestionIndex].question;
            let currentOptions = this.answers[currentQuestionIndex].options;
            this.answers[currentQuestionIndex].question = question;
            this.answers[currentQuestionIndex].category = this.questions[currentQuestionIndex].category;
            currentOptions.splice(0, currentOptions.length);
            let optionObj = {};
            dataOptionTypeElement.querySelectorAll('input[type="checkbox"]').forEach(input => {
                if (input.checked == true) {
                    optionObj = {
                        title: `${input.value}`,
                        selected: true,
                    }
                    answer.answerValue.push(input.value)
                    currentOptions.push(optionObj)
                }
                else {
                    optionObj = {
                        title: `${input.value}`,
                        selected: false,
                    }
                    currentOptions.push(optionObj);
                }
            });
            if (dataOptionType == 'indicatorOptions') {
                this.answers[currentQuestionIndex].vas_score = dataOptionTypeElement.querySelector('input[type="range"]').value;
                answer.answerScrollValue = this.answers[currentQuestionIndex].vas_score
            }
            this.answers[currentQuestionIndex].options = currentOptions;
        },
        getBiggestIndicatorValue() {
            let biggestVAS = 0;
            let indicatorWithHighestVAS = [];
            this.answers.forEach(answer => {
                if (answer.vas_score != null && biggestVAS <= answer.vas_score) {
                    biggestVAS = answer.vas_score;
                }
            });
            this.answers.forEach(answer => {
                if (biggestVAS == answer.vas_score) {
                    indicatorWithHighestVAS.push(answer.category);
                }
            });
            this.highestVASScore = biggestVAS;
            this.highestVASScoreSpanHTML = `<div class="number-labels">`;            
                for(let i=0; i<11; i++) {
                    if(i == biggestVAS) {var activeSpan = ' class="active"';}
                    else {var activeSpan = '';}
                    
                    if(i==2){var bodlFont = ' style="font-weight: bold"';}
                    else{var bodlFont = '';}
                    
                    this.highestVASScoreSpanHTML += `<span${activeSpan}${bodlFont}>${i}</span>`;
                }            
            this.highestVASScoreSpanHTML +=`</div>`;

            this.highestVASCategory = indicatorWithHighestVAS;
            let imageCharacter = '';
            if (biggestVAS == 0) {
                imageCharacter = this.indicatorImages[0];
                this.highestVASColor = '#009DC1';
                this.reportHeading = getTranslationUtility.getTranslation("Your child doesn't seem affected");
                this.reportText = getTranslationUtility.getTranslation("You've rated their symptoms as zero impact. But if you're worried, it's a good idea to discuss the full report with your doctor.");
            }
            if (biggestVAS == 1) {
                imageCharacter = this.indicatorImages[1];
                this.highestVASColor = '#8DCEC8';
                this.reportHeading = getTranslationUtility.getTranslation("Your child's symptoms seem to be mild");
                this.reportText = getTranslationUtility.getTranslation("You've rated their strongest symptoms as minor. But if you're worried, it's a good idea to discuss the full report with your doctor.");
            }
            if (biggestVAS < 5 && biggestVAS > 1) {
                imageCharacter = this.indicatorImages[2];
                this.highestVASColor = '#F1AB34';
                this.reportHeading = getTranslationUtility.getTranslation("Your child seems somewhat affected");
                this.reportText = getTranslationUtility.getTranslation("You've rated their strongest symptoms as noticeable. Talk the full report through with your doctor to figure what's going on.");
            }
            if (biggestVAS > 4) {
                imageCharacter = this.indicatorImages[3];
                this.highestVASColor = '#FF3317';
                this.reportHeading = getTranslationUtility.getTranslation("Your child seems to be struggling with symptoms");
                this.reportText = getTranslationUtility.getTranslation("You've rated their strongest symptoms as significant. Talk the full report through with your doctor so your child can get the right treatment advice.");
            }
            this.imageCharacter = imageCharacter;
        },
        createSummaryHTML() {
            let eyeIndicatorSelected = '', noseIndicatorSelected = '', breathingIndicatorSelected = '', tirednessIndicatorSelected = '';
            let pollenTrigger = '', dustTrigger = '', animalTrigger = '', otherTrigger = '', unknowTrigger = '', lifeAffectedMessage = '';
            this.highestVASCategory.forEach(highestVASCategory => {
                if (highestVASCategory == getTranslationUtility.getTranslation('Eyes')) {
                    eyeIndicatorSelected = 'active';
                }
                else if (highestVASCategory == getTranslationUtility.getTranslation('Nose')) {
                    noseIndicatorSelected = 'active';
                }
                else if (highestVASCategory == getTranslationUtility.getTranslation('Breathing')) {
                    breathingIndicatorSelected = 'active';
                }
                else if (highestVASCategory == getTranslationUtility.getTranslation('Tiredness')) {
                    tirednessIndicatorSelected = 'active';
                }
            });
            let noOFFactors = 0;
            let factorNone = false;
            this.answers[4].options.forEach(option => {
                if (option.selected == true) {
                    noOFFactors++;
                    if (option.title == getTranslationUtility.getTranslation('None')) {
                        factorNone = true;
                    }
                }
            });
            if (noOFFactors == 0 || factorNone) {
                lifeAffectedMessage = getTranslationUtility.getTranslation("Your child's life doesn't seem to be affected by their symptoms.");
            }
            else if (noOFFactors > 0 && noOFFactors < 3) {
                lifeAffectedMessage = getTranslationUtility.getTranslation("Your child's symptoms are starting to take over parts of their life.");
            }
            else if (noOFFactors >= 3) {
                lifeAffectedMessage = getTranslationUtility.getTranslation("There's a lot your child can't do or has to put up with due to their symptoms.");
            }
            this.answers[6].options.forEach(option => {
                if (option.title == getTranslationUtility.getTranslation('Pollen') && option.selected == true) {
                    pollenTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {
                    dustTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {
                    animalTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Other') && option.selected == true) {
                    otherTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('I don’t know') && option.selected == true) {
                    unknowTrigger = 'active';
                }
            });
            let summaryHTML = ``;
            summaryHTML = `
                <div class="d-md-none generalDescription">
                    <h2 class="summaryHeading" data-summary-heading="" style="color: ${this.highestVASColor};">${this.reportHeading}</h2>
                    <div class="summaryDescription">${this.reportText}</div>
                </div>
                <div class="summaryResult d-flex">
                    <div class="strugglingSymptomsContainer col-12 col-md-7">
                        <div class="d-none d-md-block generalDescription">
                            <h2 class="summaryHeading" data-summary-heading="" style="color: ${this.highestVASColor};">${this.reportHeading}</h2>
                            <div class="summaryDescription">
                                ${this.reportText}
                            </div>
                        </div>
                        <div class="strugglingSymptomsHeading">
                            ${getTranslationUtility.getTranslation('Strongest symptoms')}
                        </div>
                        <div class="indicatorIconsContainer">
                            <span class="icon-klarify-DT_results_eye_icon_grey indicatorIcons ${eyeIndicatorSelected}"></span>
                            <span class="icon-klarify-DT_results_nose_icon_grey indicatorIcons ${noseIndicatorSelected}"></span>
                            <span class="icon-klarify-DT_results_tiredness_icon_grey indicatorIcons ${tirednessIndicatorSelected}"></span>
                        </div>
                        <div class="indicatorIconsContainer">
                            <img src="${this.imageCharacter}" alt="indicator character">
                        </div>
                        <div class="resultIndicatorContainer scale-container mx-auto">
                            <div class="position-relative">                                
                                <input type="range" min="0" max="10" value="${this.highestVASScore}" class="slider" id="resultIndicator" disabled>
                                ${this.highestVASScoreSpanHTML}
                            </div>
                        </div>
                        <div class="indicatorDescription col-12 col-sm-11 col-md-10 text-center mx-auto d-none">
                            VAS SCALE. Reference: Bousquet PJ et al. Visual analog scales can assess the severity of rhinitis graded according to ARIA guidelines. Allergy. 2007;62(4):367-372.
                        </div>
                    </div>
                    <div class="d-flex col-md-5 col-12 triggerContainer mx-auto text-center">
                        <div class="dtButtonContainer d-none d-md-block">
                            <button class="d-flex">
                                <span class="buttonText get-full-report">${getTranslationUtility.getTranslation('GET FULL REPORT')}</span>
                                <span class="icon-klarify-Group-7501-1 buttonIcon"></span>
                            </button>
                        </div>
                        <div class="lifeAffectedContainer">
                            <div class="col-lg-12 mx-auto text-center">
                                <p class="lifeAffectedHeading">${getTranslationUtility.getTranslation('How daily life is affected')}</p>
                                <div class="lifeAffectedDescriptionContrainer text-center mx-auto">${lifeAffectedMessage}</div>
                            </div>
                        </div>
                        <div class="suspectedTriggersContainer">
                            <div class="col-lg-12 mx-auto text-center">
                                <p class="suspectedTriggersHeading">${getTranslationUtility.getTranslation('Suspected triggers')}</p>
                                <div class="suspectedTriggersDescriptionContainer">
                                    <div class="iconContainer ${pollenTrigger}">
                                        <span class="icon-klarify-DT_triggers_pollen_grey icon"></span>
                                        <div class="iconText">${getTranslationUtility.getTranslation('Pollen')}</div>
                                    </div>
                                    <div class="iconContainer ${dustTrigger}">
                                        <span class="icon-klarify-DT_triggers_hdm_grey icon"></span>
                                        <div class="iconText">${getTranslationUtility.getTranslation('Dust mites')}</div>
                                    </div>
                                    <div class="iconContainer ${animalTrigger}">
                                        <span class="icon-klarify-DT_triggers_animals_grey icon"></span>
                                        <div class="iconText">${getTranslationUtility.getTranslation('Animals')}</div>
                                    </div>
                                    <div class="iconContainer ${unknowTrigger} ${otherTrigger}">
                                        <span class="icon-klarify-DT_triggers_dont_know_grey icon"></span>
                                        <div class="iconText">${getTranslationUtility.getTranslation("Don't know or other")}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dtButtonContainer d-block d-md-none text-center">
                    <button class="d-flex mx-auto">
                        <span class="buttonText get-full-report">${getTranslationUtility.getTranslation('GET FULL REPORT')}</span>
                        <span class="icon-klarify-Group-7501-1 buttonIcon"></span>
                    </button>
                </div>
            `;
            this.summaryContentContainer.classList.remove('d-none');
            this.doctorContentContainer.classList.add('d-none');
            this.summaryContentContainer.innerHTML = summaryHTML;

            let getFullReportBtns = document.querySelectorAll(".dtButtonContainer button");
            getFullReportBtns.forEach(getFullReportBtn => {
                getFullReportBtn.addEventListener('click', () => {
                    document.getElementById("brazeFormMain").scrollIntoView();
                    window.dataLayer.push({
                        'event': 'qac_report_cta_click'
                    });
                });
            });

            // this.answers[6].options.forEach(option => {

            //     if (option.title == getTranslationUtility.getTranslation('Pollen') && option.selected == true) {

            //         localStorage.setItem('pageviewTree', 'true');

            //     }

            //     if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {

            //         localStorage.setItem('pageviewMite', 'true');

            //     }

            //     if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {

            //         localStorage.setItem('pageviewVenom', 'true');

            //     }

            // });

            // window.dataLayer.push({

            //     event:'web_cgr_qac_completed',

            //     persona: 'caregiver',

            //     cj_stage: 'ready_for_action',

            //     allergy_type_trees: localStorage.getItem('pageviewTree') == 'true' ? 'yes' : 'no',

            //     allergy_type_grasses: localStorage.getItem('pageviewGrass') == 'true' ? 'yes' : 'no',

            //     allergy_type_weeds: localStorage.getItem('pageviewWeed') == 'true' ? 'yes' : 'no',

            //     allergy_type_mites: localStorage.getItem('pageviewMite') == 'true' ? 'yes' : 'no',

            //     allergy_type_venom: localStorage.getItem('pageviewVenom') == 'true' ? 'yes' : 'no',

            // });
        },
        createDoctorHTML() {
            this.summaryContentContainer.classList.add('d-none');
            this.doctorContentContainer.classList.remove('d-none');
            let firstRowFirstContainerContent = ``;
            let options = ``;
            let pollenTrigger = '', dustTrigger = '', animalTrigger = '', otherTrigger = '', unknowTrigger = '', lifeAffectedMessage = '';
            this.answers.forEach(answer => {
                if (answer.category != '') {
                    let icon = ``;
                    let deskicon = ``;
                    if (answer.category == getTranslationUtility.getTranslation('Eyes')) {
                        icon = 'icon-klarify-DT_results_eye_icon_grey';
                        deskicon = 'icon-klarify-eye';
                    }
                    if (answer.category == getTranslationUtility.getTranslation('Nose')) {
                        icon = 'icon-klarify-DT_results_nose_icon_grey';
                        deskicon = 'icon-klarify-nose';
                    }
                    if (answer.category == getTranslationUtility.getTranslation('Tiredness')) {
                        icon = 'icon-klarify-DT_results_tiredness_icon_grey';
                        deskicon = 'icon-klarify-zz';
                    }
                    options = answer.options.length > 0 ? '' : '<div class="optionText active">'+ getTranslationUtility.getTranslation('Tiredness or sleep disruptions')+'</div>'
                    answer.options.forEach(option => {
                        options = options + `
                            <div class="optionText ${option.selected == true ? 'active' : ''}">${option.title}</div>
                        `;
                    })
                    let vasClass = '';
                    if (answer.vas_score == 0) {
                        vasClass = 'zero';
                    }
                    if (answer.vas_score == 1) {
                        vasClass = 'one';
                    }
                    if (answer.vas_score < 5 && answer.vas_score > 1) {
                        vasClass = 'two';
                    }
                    if (answer.vas_score > 4) {
                        vasClass = 'three';
                    }
                    firstRowFirstContainerContent = firstRowFirstContainerContent +
                        `
                        <div class="indivualIndicatorContainer text-center">
                            <div><span class="${icon} icons d-inline d-md-none"></span><span class="${deskicon} icons d-none d-md-inline"></span></div>
                            <div class="optionsTextContainer">${options}</div>
                            <button class="indicatorButton ${vasClass}">${answer.vas_score}</button>
                        </div>
                    `;
                }
            });
            let breathingOptions = ``;
            this.answers[3].options.forEach(option => {
                breathingOptions = breathingOptions + `
                    <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                    </label>`;
            });
            let dailyLifeOptions = ``;
            this.answers[4].options.forEach(option => {
                dailyLifeOptions = dailyLifeOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
            });
            let worstSymptomsOptions = ``;
            this.answers[5].options.forEach(option => {
                worstSymptomsOptions = worstSymptomsOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
            });
            let suspectedTriggersOptions = ``;
            this.answers[6].options.forEach(option => {
                suspectedTriggersOptions = suspectedTriggersOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                if (option.title == getTranslationUtility.getTranslation('Pollen') && option.selected == true) {
                    pollenTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {
                    dustTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {
                    animalTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation('Other') && option.selected == true) {
                    otherTrigger = 'active';
                }
                else if (option.title == getTranslationUtility.getTranslation("I don’t know") && option.selected == true) {
                    unknowTrigger = 'active';
                }
            });

            let familyDescription = '';
            this.answers[7].options.forEach(option => {
                if (option.title == getTranslationUtility.getTranslation('Yes') && option.selected == true) {
                    familyDescription = getTranslationUtility.getTranslation('Yes, our family does have a history of allergic conditions such as hay fever, asthma, food allergies, hives or rashes.');
                }
                else if (option.title == getTranslationUtility.getTranslation('No') && option.selected == true) {
                    familyDescription = getTranslationUtility.getTranslation('No, no one in our family has allergic conditions such as hay fever, asthma, food allergies, hives or rashes.');
                }
                else if (option.title == getTranslationUtility.getTranslation('I don’t know') && option.selected == true) {
                    familyDescription = getTranslationUtility.getTranslation('I don’t know if anyone in our family has allergic conditions such as hay fever, asthma, food allergies, hives or rashes.');
                }
            });

            let historyOptions = ``;
            this.answers[8].options.forEach(option => {
                historyOptions = historyOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
            });
            let doctorHTML = ``;
            var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            var todayDate = new Date().toLocaleDateString('de-DE', dateOptions);
            doctorHTML = `
            <div class="generalDescription d-flex">
                <div class="col-md-7 col-xl-8 dateTextContainer">
                    <div class="date">${todayDate}</div>
                    <h2 class="doctorHeading" data-doctor-heading="">${getTranslationUtility.getTranslation("My child's allergy check")}</h2>
                    <div class="doctorDescription">
                        ${getTranslationUtility.getTranslation("The full report is for the doctor, designed with guidance from other doctors to collect the details they need. Bring it with you to the appointment.")}
                    </div>
                </div>
                <div class="dtButtonContainer d-none d-md-block col-md-5 col-xl-4">
                    <button class="d-flex">
                        <span class="buttonText get-full-report">${getTranslationUtility.getTranslation('GET FULL REPORT')}</span>
                        <span class="icon-klarify-Group-7501-1 buttonIcon"></span>
                    </button>
                </div>
            </div>
            <div class="doctorResult">
                <div class="firstrow d-flex">
                    <div class="firstRowFirstContainer">
                        <div class="container">
                            <div class="titleContainer">${getTranslationUtility.getTranslation("My child’s symptom overview")}</div>
                            <div class="d-flex">
                                <div class="indicatorContainer">
                                    <div class="d-flex">
                                        ${firstRowFirstContainerContent}
                                    </div>
                                    <div class="labels labelMobile">
                                        <span class="sliderNotAffected indicatorText">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                        <span class="sliderVeryAffected indicatorText">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                    </div>
                                    <div class="position-relative sliderContainer">
                                        <input type="range" min="0" max="10" value="0" class="slider">
                                        <div class="number-labels">
                                            <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                            <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                        </div>
                                    </div>
                                    <div class="labels labelDesktop">
                                        <span class="sliderNotAffected indicatorText">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                        <span class="sliderVeryAffected indicatorText">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                    </div>
                                    <div class="indicatorDescription">
                                    ${getTranslationUtility.getTranslation('The VAS for allergic rhinitis (nose symptoms) and allergic conjunctivitis (eye symptoms) adapted from: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.')}
                                    </div>
                                </div>
                                <div class="breathingContainer">
                                    <div class="breathingHeader">${getTranslationUtility.getTranslation('BREATHING ISSUES')}</div>
                                    <div class="breathingOptions">${breathingOptions}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="firstRowSecondContainer">
                        <div class="container h-100">
                            <div class="titleContainer">${getTranslationUtility.getTranslation('Impact on daily life')}</div>
                            <div class="dailyLifeContainer">
                                <div class="dailyLifeHeader">${getTranslationUtility.getTranslation("ASPECTS OF MY CHILD'S LIFE AFFECTED")}</div>
                                <div class="dailyLifeOptions">${dailyLifeOptions}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="secondrow">
                    <div class="secondRowFirstContainer">
                        <div class="container">
                            <div class="titleContainer">${getTranslationUtility.getTranslation('Timing and triggers')}</div>
                            <div class="contentContainer">
                                <div class="secondRowFirstPart">
                                    <div class="worstSymptomsHeader">${getTranslationUtility.getTranslation('WHEN SYMPTOMS ARE WORST')}</div>
                                    <div class="worstSymptomsOptions">${worstSymptomsOptions}</div>
                                </div>
                                <div class="secondRowSecondPart">
                                    <div class="suspectedTriggersHeader">${getTranslationUtility.getTranslation('Suspected triggers')}</div>
                                    <div class="suspectedTriggersContent">
                                        <div class="suspectedTriggersOptions col-12 col-md-5 col-lg-4">${suspectedTriggersOptions}</div>
                                        <div class="suspectedTriggersIconsContainer col-12 col-md-7 col-lg-8">
                                            <div class="suspectedTriggersIconsSubContainer">
                                                <div class="iconContainer ${pollenTrigger}">
                                                    <span class="icon-klarify-DT_triggers_pollen_grey icon"></span>
                                                    <div class="iconText">${getTranslationUtility.getTranslation('Pollen')}</div>
                                                </div>
                                                <div class="iconContainer ${dustTrigger}">
                                                    <span class="icon-klarify-DT_triggers_hdm_grey icon"></span>
                                                    <div class="iconText">${getTranslationUtility.getTranslation('Dust mites')}</div>
                                                </div>
                                                <div class="iconContainer ${animalTrigger}">
                                                    <span class="icon-klarify-DT_triggers_animals_grey icon"></span>
                                                    <div class="iconText">${getTranslationUtility.getTranslation('Animals')}</div>
                                                </div>
                                                <div class="iconContainer ${unknowTrigger} ${otherTrigger}">
                                                    <span class="icon-klarify-DT_triggers_dont_know_grey icon"></span>
                                                    <div class="iconText">${getTranslationUtility.getTranslation("Don't know or other")}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="thirdrow">
                    <div class="container">
                        <div class="titleContainer">${getTranslationUtility.getTranslation('Medical history')}</div>
                        <div class="contentContainer">
                            <div class="thirdRowFirstPart">
                                <div class="familyHeader">${getTranslationUtility.getTranslation('ALLERGIES IN OUR FAMILY')}</div>
                                <p class="familyDescription">${familyDescription}</p>
                            </div>
                            <div class="thirdRowSecondPart">
                                <div class="historyHeader">${getTranslationUtility.getTranslation('MY CHILD HAS OR USED TO HAVE:')}</div>
                                <div class="historyOptions">${historyOptions}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dtButtonContainer d-block d-md-none text-center">
                 <button class="d-flex mx-auto">
                    <span class="buttonText get-full-report">${getTranslationUtility.getTranslation('GET FULL REPORT')}</span>
                    <span class="icon-klarify-Group-7501-1 buttonIcon"></span>
                </button>
            </div>
            `;
            this.doctorContentContainer.innerHTML = doctorHTML;
            let getFullReportBtns = document.querySelectorAll(".dtButtonContainer button");
            getFullReportBtns.forEach(getFullReportBtn => {
                getFullReportBtn.addEventListener('click', () => {
                    document.getElementById("brazeFormMain").scrollIntoView();
                    window.dataLayer.push({
                        'event': 'qac_report_cta_click'
                    });
                });
            });
        },
        async sendAnswer(bodyData) {
            try {
                const response = await fetch(`https://alk-app.klarify.me/api/quick-allergy-check`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${window.klarifyAppToken}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(bodyData)
                });
                const res = await response.json();

                if(response.status == 200) {
                    let pdfLink = res.link;
                    let externalId = this.QACID_Cookie;
                    let bodyDataMap = {
                        "external_id": externalId,
                        "url": pdfLink,
                        "newsletter_signup": this.newsletterSignupVal,
                    };
                    // if(document.querySelector('#brazeFormMain .signup').classList.contains('d-none')){
                        this.sendPDFtoBraze(bodyDataMap); 
                    // }     
                }
            } catch (e) {
                console.error('Filter API call failed', e);
            }
        },
        async sendPDFtoBraze(bodyDataMap) {
            try {
                response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${window.datahubAPIKey}`,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(bodyDataMap)
                    })
                    if(response.status === 200){
                        await response.json();
                    }
            } catch (e) {
                console.error('Filter API call failed', e);
            }
        },
        setCookie(name, value, minutes) {
            let date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
            document.cookie = name + "=" + c_value;

            return document.cookie;
        },
        getCookie(name) {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith(name + '=')) {
                    return cookie.substring(name.length + 1);
                }
            }
            return null; // Cookie not found
        },   
    };
    window.quickAllergyCheck.init();
}